import type React from 'react';
import { Button, Flex, RiAddBoxLine } from '@itandi/itandi-bb-ui';
import Styles from './ConstructionTop.module.scss';
import type { DealConstructionContext } from '~/models/DealConstruction';
import { MEDIA_QUERY, useMediaQuery } from '~/hooks/useMediaQuery';
import { ConstructionDownloadButtons } from './ConstructionDownloadButtons';

type Props = {
  readonly: boolean;
  constructionContext: DealConstructionContext;
  dealEstimationHistoryContext: DealConstructionContext | null;
  dealEstimationDraftHeader: DealConstructionContext | null;
  handleClickEstimationPreview: (() => void) | null;
  handleClickEstimationHistoryPreview: (() => void) | null;
  handleClickBillingPreview: (() => void) | null;
  handleClickShowAddModal: (() => void) | null;
  handleClickChangeAmount: (() => void) | null;
  handleClickGenerateBillings: (() => void) | null;
  handleClickCreateHeader: (() => void) | null;
  handleClickDestroyHeader: (() => void) | null;
  billingTarget: 'owner' | 'rentee' | null;
  estimationAddDisabled: boolean;
  ownManagement: boolean;
  useSK: boolean;
};

export const ConstructionActions: React.FC<Props> = ({
  readonly,
  constructionContext,
  dealEstimationHistoryContext,
  dealEstimationDraftHeader,
  handleClickEstimationPreview,
  handleClickEstimationHistoryPreview,
  handleClickBillingPreview,
  handleClickShowAddModal,
  handleClickChangeAmount,
  handleClickGenerateBillings,
  handleClickCreateHeader,
  handleClickDestroyHeader,
  billingTarget,
  estimationAddDisabled,
  ownManagement,
  useSK
}: Props) => {
  const { match: isSp, isLoaded: windowLoaded } = useMediaQuery(MEDIA_QUERY.sp);
  if (!windowLoaded) return null;
  return (
    <Flex
      direction={isSp ? 'column' : 'row'}
      gap="8px"
      marginLeft="auto"
      paddingX="8px"
      width={isSp ? '100%' : 'auto'}
    >
      {handleClickChangeAmount !== null && (
        <Button
          onClick={handleClickChangeAmount}
          variant="tertiary"
          width={isSp ? 'fill' : 'default'}
        >
          施工単価一括変更
        </Button>
      )}
      {handleClickGenerateBillings && (
        <Button
          onClick={handleClickGenerateBillings}
          variant="tertiary"
          width="default"
        >
          請求再作成
        </Button>
      )}
      {handleClickCreateHeader !== null && (
        <Button
          disabled={
            dealEstimationHistoryContext !== null &&
            dealEstimationHistoryContext.dealConstructions.length !== 0
          }
          onClick={handleClickCreateHeader}
          variant="tertiary"
          width={isSp ? 'fill' : 'default'}
        >
          棄却された見積りを復元
        </Button>
      )}
      {billingTarget === null &&
        dealEstimationDraftHeader &&
        handleClickDestroyHeader &&
        !ownManagement && (
          <Button
            disabled={dealEstimationDraftHeader.dealConstructions.length === 0}
            onClick={handleClickDestroyHeader}
            variant="tertiary"
            width={isSp ? 'fill' : 'default'}
          >
            見積りを元に戻す
          </Button>
        )}
      <ConstructionDownloadButtons
        billingTarget={billingTarget}
        constructionContext={constructionContext}
        dealEstimationDraftHeader={dealEstimationDraftHeader}
        dealEstimationHistoryContext={dealEstimationHistoryContext}
        handleClickBillingPreview={handleClickBillingPreview}
        handleClickEstimationHistoryPreview={
          handleClickEstimationHistoryPreview
        }
        handleClickEstimationPreview={handleClickEstimationPreview}
        isSp={isSp}
        ownManagement={ownManagement}
        useSK={useSK}
      />
      {handleClickShowAddModal !== null && !readonly && (
        <div className={Styles.AddButton}>
          <Button
            disabled={estimationAddDisabled}
            onClick={handleClickShowAddModal}
            startIcon={<RiAddBoxLine />}
            variant="secondary"
            width={isSp ? 'fill' : 'default'}
          >
            項目追加
          </Button>
        </div>
      )}
    </Flex>
  );
};
